import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var RightDownArrowCircle = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M12 2.007a9.928 9.928 0 00-7.071 2.922c-3.899 3.899-3.899 10.243 0 14.143A9.93 9.93 0 0012 21.995a9.93 9.93 0 007.071-2.923c3.899-3.899 3.899-10.243 0-14.143A9.928 9.928 0 0012 2.007zm5.657 15.65A7.946 7.946 0 0112 19.994c-2.141 0-4.15-.83-5.657-2.337-3.119-3.119-3.119-8.195 0-11.314A7.944 7.944 0 0112 4.007c2.141 0 4.15.829 5.657 2.336 3.119 3.119 3.119 8.195 0 11.314z",
    key: "k0"
  }), React.createElement("path", {
    d: "M9.661 8.247L8.247 9.661l3.214 3.214L9.336 15H15V9.337l-2.125 2.124z",
    key: "k1"
  }));
});
RightDownArrowCircle.displayName = 'RightDownArrowCircle';
export var RightDownArrowCircleDimensions = {
  height: 24,
  width: 24
};